import { AfterViewInit, Component, ElementRef, model, signal, viewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ICellEditorAngularComp } from 'ag-grid-angular'
import type { ICellEditorParams } from 'ag-grid-community'

const accept = (key: string) => {
  if (key.length === 1) {
    return key === '-' || (key >= '0' && key <= '9')
  } else {
    return true
  }
}

@Component({
  selector: 'div[app-number-cell-editor]',
  imports: [
    FormsModule,
  ],
  styles: `
    :host {
      width: 100%;
      height: 100%;
      
      input {
        border: none;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        text-align: right;
        padding-right: 1rem;
        font-size: 14px;
        :focus {
          border: none;
          box-shadow: none;
        }
      }
    }
  `,
  template: `
    <input
        #input
        class='form-control'
        [(ngModel)]="model"
        (keydown)="onKeyDown($event)"
    >
  `,
})
export class NumberCellEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public readonly model = model<string>('')
  private originalValue = signal<number | undefined>(undefined)

  private inputRef = viewChild<ElementRef<HTMLInputElement>>('input')

  ngAfterViewInit() {
    setTimeout(() => {
      const element = this.inputRef()?.nativeElement
      if (element) {
        element.focus()
        element.select()
      }
    }, 0)
  }

  agInit({ value }: ICellEditorParams<unknown, number>) {
    this.originalValue.set(value ?? undefined)
    this.model.set(typeof value === 'number' ? String(value) : '')
  }

  getValue(): number | undefined {
    const text = this.model().trim()
    if (text) {
      const n = Number(text)
      return Number.isFinite(n) ? n : this.originalValue()
    } else {
      return undefined
    }
  }

  protected onKeyDown(event: KeyboardEvent) {
    const { key, ctrlKey, altKey, metaKey } = event
    if (!ctrlKey && !altKey && !metaKey && !accept(key)) {
      event.preventDefault()
    }
  }
}